// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._syaz1fxt{color:var(--ds-text,#172b4d)}", ""]);
// Exports
module.exports = exports;
